import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  ButtonGroup,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  CircularProgress,
} from "@material-ui/core";
import {
  Close,
  Edit,
  Block,
  CheckCircle,
  DesktopMac,
  Add,
  FilterList,
  Settings,
  ArrowForwardIos,
} from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { useSnackbar } from "notistack";
import { makeStyles, useTheme } from "@material-ui/styles";

import { AdminService,Permissions } from "../../../utils/web_config";

import Format from "date-fns/format";

import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function getSteps() {
  return ["Agent info", "Finish edit"];
}

function CorporateDetails(props) {
  const classes = useStyles();
  const history = useHistory();
  const Theme = useTheme();
  const data = history.location?.state;

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [agents, setAgents] = useState({
    saving: false,
    loadfing: false,
    edit: false,
    toggling: false,
  });

  const [warning, setWarning] = useState(false);

  const [agentName, setName] = useState({ value: "", error: "" });
  const [agentEmail, setEmail] = useState({ value: "", error: "" });
  const [agentPhone, setPhone] = useState({ value: "", error: "" });
  const [agentAddress, setAddress] = useState({ value: "", error: "" });
  const [agentShortName, setShortName] = useState({ value: "", error: "" });

  const [agentWebsite, setWebsite] = useState({ value: "", error: "" });
  const [agentTin, setTin] = useState({ value: "", error: "" });
  const [agentFax, setFax] = useState({ value: "", error: "" });
  const [agentZip, setZip] = useState({ value: "", error: "" });
  const [agentContractNumber, setContractNumber] = useState({
    value: "",
    error: "",
  });
  const [agentCotractStart, setCotractStart] = useState({
    value: new Date(),
    error: "",
  });
  const [agentContractEnd, setContractEnd] = useState({
    value: new Date(),
    error: "",
  });

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  /////////////////////

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);

    fillForm();
  }, []);

  ///////////////

  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_name")}
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };
  const onEmailChange = (event) => {
    if (event.target.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_email")}
          </Translate>
        ),
      });
    } else {
      setEmail({ value: event.target.value, error: "" });
    }
  };
  const onPhoneChange = (event) => {
    if (event.target.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_phone")}
          </Translate>
        ),
      });
    } else {
      setPhone({ value: event.target.value, error: "" });
    }
  };
  const onAddressChange = (event) => {
    if (event.target.value === "") {
      setAddress({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_address")}
          </Translate>
        ),
      });
    } else {
      setAddress({ value: event.target.value, error: "" });
    }
  };
  const onShortNameChange = (event) => {
    if (event.target.value === "") {
      setShortName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_short_name")
            }
          </Translate>
        ),
      });
    } else {
      setShortName({ value: event.target.value, error: "" });
    }
  };

  const onWebsiteChange = (event) => {
    if (event.target.value === "") {
      setWebsite({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_website")}
          </Translate>
        ),
      });
    } else {
      setWebsite({ value: event.target.value, error: "" });
    }
  };
  const onTinChange = (event) => {
    if (event.target.value === "") {
      setTin({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_tin")}
          </Translate>
        ),
      });
    } else {
      setTin({ value: event.target.value, error: "" });
    }
  };
  const onFaxChange = (event) => {
    if (event.target.value === "") {
      setFax({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_fax")}
          </Translate>
        ),
      });
    } else {
      setFax({ value: event.target.value, error: "" });
    }
  };
  const onZipChange = (event) => {
    if (event.target.value === "") {
      setZip({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_zip")}
          </Translate>
        ),
      });
    } else {
      setZip({ value: event.target.value, error: "" });
    }
  };
  const onContractNumberChange = (event) => {
    if (event.target.value === "") {
      setContractNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_contract_number")
            }
          </Translate>
        ),
      });
    } else {
      setContractNumber({ value: event.target.value, error: "" });
    }
  };
  const onCnotractStartChange = (date) => {
    setCotractStart({ value: date, error: "" });
  };
  const onContractEndChange = (date) => {
    setContractEnd({ value: date, error: "" });
  };

  //////////////////////

  const onRegisterClick = () => {
    if (agentName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_name")}
          </Translate>
        ),
      });
    } else if (agentEmail.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_email")}
          </Translate>
        ),
      });
    } else if (agentPhone.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_phone")}
          </Translate>
        ),
      });
    } else if (agentAddress.value === "") {
      setAddress({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_address")}
          </Translate>
        ),
      });
    } else if (agentShortName.value === "") {
      setShortName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_short_name")
            }
          </Translate>
        ),
      });
    } else if (agentTin.value === "") {
      setTin({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_tin")}
          </Translate>
        ),
      });
    } 
    else if (agentContractNumber.value === "") {
      setContractNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_contract_number")
            }
          </Translate>
        ),
      });
    } else if (agentCotractStart.value === "") {
      setCotractStart({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_contract_start")
            }
          </Translate>
        ),
      });
    } else if (agentContractEnd.value === "") {
      setContractEnd({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_contract_end")
            }
          </Translate>
        ),
      });
    } else {
      setActiveStep(1);
      if (activeStep === 1) {
        updateOp();
      }
    }
  };
  ///////////////
  ///////////////////////////////

  const fillForm = () => {
    setContractEnd({ value: new Date(data.contract_end_date), error: "" });
    setCotractStart({ value: new Date(data.contract_start_date), error: "" });
    setContractNumber({ value: data.contract_number, error: "" });
    setEmail({ value: data.email, error: "" });
    setFax({ value: data.fax_number, error: "" });
    setAddress({ value: data.full_address, error: "" });
    setName({ value: data.name, error: "" });
    setPhone({ value: data.phone_number, error: "" });
    setShortName({ value: data.short_name, error: "" });
    setTin({ value: data.tin, error: "" });
    setWebsite({ value: data.website, error: "" });
    setZip({ value: data.zip_number, error: "" });
  };
  /////////

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  ///////////////////////////////////
  const updateOp = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setAgents({ ...agents, saving: true });

    const data2 = {
      booking_limit: 0,
      contract_end_date: Format(agentContractEnd.value, [
        "yyyy-MM-dd HH:mm:ss",
      ]),
      contract_number: agentContractNumber.value,
      contract_start_date: Format(agentCotractStart.value, [
        "yyyy-MM-dd HH:mm:ss",
      ]),
      email: agentEmail.value,
      fax_number: agentFax.value,
      full_address: agentAddress.value,
      name: agentName.value,
      organization_type: "AGENT",
      phone_number: agentPhone.value,
      registration_date: Format(new Date(), ["yyyy-MM-dd HH:mm:ss"]),
      short_name: agentShortName.value,
      tin: agentTin.value,
      website: agentWebsite.value,
      zip_number: agentZip.value,
    };

    console.log("Editing agent .....");
    //console.log(data);

    createInstance
      .put(new AdminService().UPDATE_ORGANIZATION + data.organization_id, data2)
      .then(function (response) {
        setAgents({ ...agents, saving: false });

        const d = response.data;

        setAgents({ ...agents, data: d.data });

        notify("success", response.data.message);
        setAgents({ ...agents, edit: false });
        setActiveStep(0);
      })
      .catch(function (error) {
        setAgents({ ...agents, saving: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////////////////////
  const toggleAgent = () => {
    const agInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAgents({ ...agents, toggling: true });

    console.log("toggling op.....");

    var url;
    if (data.organization_status == "ENABLED") {
      url = new AdminService().DEACTIVATE_ORGANIZATION + data.organization_id;
      data["organization_status"] = "DISABLED";
    } else {
      url = new AdminService().REACTIVATE_ORGANIZATION + data.organization_id;
      data["organization_status"] = "ENABLED";
    }

    agInstance
      .put(url)
      .then(function (response) {
        const d = response.data;
        setAgents({ ...agents, toggling: false });

        notify("success", d.data);
      })
      .catch(function (error) {
        setAgents({ ...agents, toggling: false });

        data["organization_status"] =
          data.organization_status == "ENABLED" ? "DISABLED" : "ENABLED";
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        {/* Dialogs ends here */}

        <Dialog
          open={warning}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You are about to deactivate this agent, all his actions and
              transactions will stop working until you reactivate him.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setWarning(false);
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setWarning(false);
                toggleAgent();
              }}
              color="primary"
              autoFocus
            >
              Deactivate
            </Button>
          </DialogActions>
        </Dialog>
        {/* ///////////////////////////////////// */}

        <Box display="flex" alignItems="center">
          <Box mr={2}>
            {" "}
            <Settings color="primary" fontSize="large" />
          </Box>
          <Box flexGrow={1} display="flex" alignItems="center">
            <Typography variant="h5">
              <b>Agent settings </b>
            </Typography>
          </Box>
        </Box>
        <Box mt={3} />
        <Grid container justify="center">
          <Grid item xs={12} md={7}>
            <Box display="flex" justifyContent="center" mt={4} mb={3}>
              <Button
                className={classes.btn}
                style={{
                  color:
                    data.organization_status == "ENABLED"
                      ? Theme.palette.error.main
                      : Theme.palette.primary.main,
                }}
                size="large"
                variant="contained"
                startIcon={
                  agents.toggling ? (
                    <CircularProgress size={25} />
                  ) : data.status == "ENABLED" ? (
                    <Block />
                  ) : (
                    <CheckCircle />
                  )
                }
                disabled={agents.toggling}
                onClick={() =>
                  data.organization_status == "ENABLED"
                    ? setWarning(true)
                    : toggleAgent()
                }
                disableElevation
              >
                {data.organization_status == "ENABLED"
                  ? "Deactivate agent"
                  : "Reactivate agent"}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} className={classes.paper}>
              <DialogContent>
                {/* <Box mt={1} mb={1}>
            <LinearProgress variant="determinate" value={40} />
          </Box> */}

                <Box width={1}>
                  {!agents.edit ? (
                   <Permissions permissions='CAN_EDIT_AGENT'> <Box pt={2} display="flex" justifyContent="center">
                      <Button
                        color="primary"
                        className={classes.btn}
                        startIcon={<Edit />}
                        onClick={() => setAgents({ ...agents, edit: true })}
                      >
                        Edit agent info
                      </Button>
                    </Box>
                      </Permissions>
                  ) : (
                    <Stepper
                      activeStep={activeStep}
                      alternativeLabel
                      style={{ padding: 0 }}
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  )}
                  <div>
                    {activeStep === steps.length ? (
                      <div>
                        <Typography className={classes.instructions}>
                          All steps completed
                        </Typography>
                        <Button>Reset</Button>
                      </div>
                    ) : (
                      <div>
                        {activeStep == 0 ? (
                          <Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentName.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_name"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_name" />
                                    }
                                    fullWidth
                                    onChange={onNameChange}
                                    helperText={agentName.error}
                                    error={agentName.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentEmail.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_email"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_email" />
                                    }
                                    fullWidth
                                    onChange={onEmailChange}
                                    helperText={agentEmail.error}
                                    error={agentEmail.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentPhone.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_phone"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_phone" />
                                    }
                                    fullWidth
                                    onChange={onPhoneChange}
                                    helperText={agentPhone.error}
                                    error={agentPhone.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentAddress.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_address"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_address" />
                                    }
                                    fullWidth
                                    onChange={onAddressChange}
                                    helperText={agentAddress.error}
                                    error={agentAddress.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentShortName.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_short_name"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_short_name" />
                                    }
                                    fullWidth
                                    onChange={onShortNameChange}
                                    helperText={agentShortName.error}
                                    error={agentShortName.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>

                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentWebsite.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_website"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_website" />
                                    }
                                    fullWidth
                                    onChange={onWebsiteChange}
                                    helperText={agentWebsite.error}
                                    error={agentWebsite.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>

                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentTin.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_tin"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_tin" />
                                    }
                                    fullWidth
                                    onChange={onTinChange}
                                    helperText={agentTin.error}
                                    error={agentTin.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>

                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentZip.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_zip"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_zip" />
                                    }
                                    fullWidth
                                    onChange={onZipChange}
                                    helperText={agentZip.error}
                                    error={agentZip.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentFax.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_fax"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_fax" />
                                    }
                                    fullWidth
                                    onChange={onFaxChange}
                                    helperText={agentFax.error}
                                    error={agentFax.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !agents.edit,
                                      readOnly: !agents.edit,
                                    }}
                                    value={agentContractNumber.value}
                                    placeholder={translate(
                                      "agents.forms.hints.agent_contract_number"
                                    )}
                                    label={
                                      <Translate id="agents.forms.labels.agent_contract_number" />
                                    }
                                    fullWidth
                                    onChange={onContractNumberChange}
                                    helperText={agentContractNumber.error}
                                    error={agentContractNumber.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <DatePicker
                                fullWidth
                                disableToolbar
                                variant="inline"
                                format="yyyy-MM-dd"
                                margin="dense"
                                autoOk
                                label={
                                  <Translate id="agents.forms.labels.agent_contract_start" />
                                }
                                value={agentCotractStart.value}
                                inputVariant="standard"
                                onChange={onCnotractStartChange}
                                InputProps={{
                                  disableUnderline: !agents.edit,
                                  readOnly: !agents.edit,
                                  style: { paddingRight: 0 },
                                }}
                              />
                            </Box>
                            <Box mt={2}>
                              <DatePicker
                                fullWidth
                                disableToolbar
                                variant="inline"
                                format="yyyy-MM-dd"
                                margin="dense"
                                autoOk
                                label={
                                  <Translate id="agents.forms.labels.agent_contract_end" />
                                }
                                value={agentContractEnd.value}
                                inputVariant="standard"
                                onChange={onContractEndChange}
                                InputProps={{
                                  disableUnderline: !agents.edit,
                                  readOnly: !agents.edit,
                                  style: { paddingRight: 0 },
                                }}
                              />
                            </Box>
                          </Box>
                        ) : (
                          <Box m={4}>
                            <Typography align="center">
                              <Translate id="agents.forms.dialog_desc" />
                            </Typography>
                          </Box>
                        )}
                      </div>
                    )}
                  </div>

                  <Box mt={3} />
                  {agents.edit && (
                    <DialogActions>
                      <Button
                        variant="outlined"
                        color="primary"
                        disableElevation
                        className={classes.btn}
                        onClick={() => {
                          activeStep === 0
                            ? setAgents({ ...agents, edit: false })
                            : handleBack();
                        }}
                      >
                        {activeStep === 0 ? (
                          <Translate id="agents.forms.buttons.cancel" />
                        ) : (
                          <Translate id="agents.forms.buttons.back" />
                        )}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation
                        className={classes.btn}
                        disabled={agents.saving}
                        onClick={() => {
                          onRegisterClick();
                        }}
                      >
                        {agents.saving ? (
                          <CircularProgress size={25} />
                        ) : activeStep === steps.length - 1 ? (
                          <Translate id="agents.forms.buttons.save" />
                        ) : (
                          <Translate id="agents.forms.buttons.continue" />
                        )}
                      </Button>
                    </DialogActions>
                  )}
                </Box>
              </DialogContent>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default withLocalize(CorporateDetails);
